import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const XdockV2RBAC = {
  pageID: '9067d891fff0a65f4095ddb5a32998cb',
  elementID: {
    ViewPage: '96d2cbc2188b90a212f7324c1b0c6b3d',
    ButtonCompletePooling: 'b6720ed8b0b082338ff30451dd7af158',
    ButtonAssignStaff: '94cba23122da564b48d7621a2e5cf5ce',
    ButtonChangeStaff: '100d7f869deac7fe260e3dd4a393348b',
    ButtonPrintSortingLabel: 'bde8c9e397560f6dd8cb54c7561ef86e',
    ButtonPrintDTCLabel: 'b37530db2b500e296d710a78fa262343',
  },
} as const

export const useRBACXdockV2Page = createUseRBAC(XdockV2RBAC.elementID)

export type UseRBACXdockV2PageType = ReturnType<typeof useRBACXdockV2Page>
